import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useGuiaEntradaCompraStore } from '../store/guiaEntradaCompraStore';

const estadoColors: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  CER: 'success', PEN: 'warning', ANU: 'error',
};
const estadoLabels: Record<string, string> = {
  CER: 'Cerrada', PEN: 'Pendiente', ANU: 'Anulada',
};

export const GuiasEntradaCompraPage: React.FC = () => {
  const navigate = useNavigate();
  const { items, loading, fetchAll } = useGuiaEntradaCompraStore();

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const columns: GridColDef[] = [
    { field: 'numero', headerName: 'Numero', width: 120 },
    { field: 'serie', headerName: 'Serie', width: 80 },
    { field: 'nroDocumento', headerName: 'Nro Doc.', width: 120 },
    {
      field: 'fechaEmision', headerName: 'F. Emision', width: 120,
      valueFormatter: (value: string) => {
        try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; }
      },
    },
    { field: 'proveedor', headerName: 'Proveedor', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.razonSocial || '-' },
    { field: 'depositoDestino', headerName: 'Almacen Destino', width: 150, valueGetter: (value: any) => value?.descripcion || '-' },
    {
      field: 'estado', headerName: 'Estado', width: 120,
      renderCell: (params) => (
        <Chip label={estadoLabels[params.value] || params.value || '-'} color={estadoColors[params.value] || 'default'} size="small" />
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Guias de Entrada</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/compras/guia-entrada/nueva')}>Nueva Guia</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid
          rows={items} columns={columns} getRowId={(row) => row.idGuiaEntradaCompra}
          loading={loading} pageSizeOptions={[10, 20, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/compras/guia-entrada/${params.row.idGuiaEntradaCompra}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
};
